import styled from 'styled-components';

interface CheckboxItemProps {
  isDefault?: boolean;
}

interface AnimatedArrowProps {
  state: boolean;
}

interface ModalContainerProps {
  isModalOpen: boolean;
}

interface ConflictItemProps {
  isPreviousInConflict?: boolean;
}

export const ButtonAndModalWrapper = styled.div`
  position: relative;
`;

export const LayerTouchable = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 99vw;
  height: 120vh;
`;

export const Container = styled.div`
  background: #ffffff;
  border: 1px solid #e4e9f0;
  box-sizing: border-box;
  box-shadow: 0px 2px 1px rgba(0, 34, 102, 0.05);
  border-radius: 100px;
  width: 100%;
  height: 46px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;

  span {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 10px;
    color: #98a2b3;
  }

  .course-highlighted {
    color: #4a90e2;
    margin-left: 3px;
  }
`;

export const ModalContainer = styled.div<ModalContainerProps>`
  position: absolute;
  top: 56px;
  left: 0;
  cursor: default;
  width: 100%;

  background: #ffffff;
  border: 1px solid #e4e9f0;
  box-sizing: border-box;
  box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.25);
  border-radius: 4px;

  z-index: ${({ isModalOpen }) => (isModalOpen ? 50 : 10)};
`;

export const ModalWrapper = styled.div`
  max-height: 350px;
  overflow-y: scroll;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e4e9f0;
  width: 100%;

  input {
    border: none;
    flex: 1;
    padding: 13px 40px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;

    &::placeholder {
      font-weight: 300;
      font-size: 12px;
      line-height: 10px;
      letter-spacing: 0.5px;
      color: #98a2b3;
    }
  }

  img {
    margin-right: 20px;
    width: 15px;
  }
`;

export const CheckboxItem = styled.div<CheckboxItemProps>`
  display: flex;
  align-items: center;
  margin: 24px 40px;

  input {
    cursor: pointer;
  }

  label {
    cursor: pointer;
    margin: 0 0 0 10px !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 10px !important;
    letter-spacing: 0.5px !important;
    color: ${({ isDefault }) => (isDefault ? '#4a90e2' : '#7A8799')} !important;

    span {
      font-weight: 300;
      font-size: 10px;
      line-height: 11px;
      color: #98a2b2;
      margin-left: 8px;
    }
  }
`;

export const ModalFooter = styled.div`
  background: #f5f7fa;
  border-radius: 0px 0px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  width: 100%;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 50%;
  margin-right: 20px;
  align-items: center;
  justify-content: space-between;
`;

export const AnimatedArrow = styled.img<AnimatedArrowProps>`
  transition: 300ms;
  transform: rotate(${({ state }) => (state ? 180 : 0)}deg);
`;

export const ConflictItem = styled.div<ConflictItemProps>`
  display: flex;
  flex-direction: column;
  margin: 10px 12px 12px 61px;
  color: #bbbbbb;

  .conflict-course__title {
    font-weight: 500 !important;
    font-size: 12px !important;
    color: #bbbbbb;
    letter-spacing: 0.5px !important;
    margin-bottom: 5px;

    span {
      margin-left: 8px;
      color: #bbbbbb;
      font-weight: 400;
      font-size: 10px;
      line-height: 11px;
    }
  }

  .conflict-description {
    font-weight: 400;
    font-size: 10px;
    line-height: 11px;
    margin: 0;
  }
`;
